import { isIFrame } from '@ms/yammer-web-authenticators';

import { rejectAfter } from '../promises';

interface RegisterServiceWorkerOptions {
  readonly path: string;
  readonly scope: string;
}

export const serviceWorkerTimeout = 5000;
// Five seconds is too long if the app renders in an iframe.
// While other workloads are running sign out process, they will not wait 5 seconds
// for the Glammer's logout process to be done. Reduced to 3.5 seconds to significantly increase
// the successful rate of auth cookies and session storage cleaning, as well as the AAD sign out process.
export const serviceWorkerIframeTimeout = 3500;

type RegisterServiceWorker = (options: RegisterServiceWorkerOptions) => Promise<void>;
export const registerServiceWorker: RegisterServiceWorker = async ({ path, scope }) => {
  await navigator.serviceWorker.register(`${scope}${path}`, { scope });
};

export const serviceWorkerReady = (): Promise<ServiceWorkerRegistration> => {
  // `navigator.serviceWorker.ready` may never resolve if the ServiceWorker
  // doesn't activate. That's why we race it against a timeout.
  const serviceWorkerPromise = navigator.serviceWorker.ready;
  const timeout = isIFrame() ? serviceWorkerIframeTimeout : serviceWorkerTimeout;
  const timeoutPromise = rejectAfter(timeout, new Error('ServiceWorker did not activate'));

  return Promise.race([serviceWorkerPromise, timeoutPromise]) as Promise<ServiceWorkerRegistration>;
};
